<template>
  <div>
    <!-- <h3>Hola KPI Satisfaccion Clientes</h3> -->

    <el-row>
      <el-col>
        <!-- <h1>KPI Cumplimiento SLA</h1> -->
        <yearcomponent
          ref="yearC"
          @change="handler_year"
          v-model="year"
        ></yearcomponent>

        <!-- <el-select
          v-model="valoracionId"
          @change="handlerChangesValoracion"
          placeholder="Tipo de Valoración"
          size="mini"
          class="ml-5"
        >
          <el-option label="Todas las Solicitudes" :value="0"></el-option>
          <el-option label="Calificadas" :value="1"></el-option>
         <el-option value="0">Todas las Solicitudes</el-option>
          <el-option value="1">Calificadas</el-option>
        </el-select> -->
        <el-select
          v-model="valoracionTypeID"
          @change="handlerChanges"
          size="mini"
          clearable
          placeholder="Tipo de Solicitud"
          class="ml-5"
        >
          <el-option
            v-for="item in Valor"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        <el-select
          v-model="serviceTypeID"
          @change="handlerChangesServices"
          size="mini"
          clearable
          placeholder="Tipo de servicio"
          class="ml-5"
        >
          <el-option
            v-for="item in list_types_to_select"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <el-select
          v-model="product"
          @change="handlerChangesProduct"
          size="mini"
          clearable
          placeholder="Productos"
          class="ml-5"
        >
          <el-option
            v-for="item in list_products"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <rabbey-table2
          :columns="columns2"
          :show-summary="true"
          :summary-method="getTotalByMonthSLA"
          :default-items="technicalTracker"
          :paginateFromApi="false"
          v-loading="principalTable"
        />
      </el-col>
    </el-row>

    <!-- table detalle por Vendedor -->
    <DetailSatisfaccionKpi ref="details" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import yearcomponent from "@/components/Global_System/YearsComponent.vue";
import { Months, commentColumns } from "@/helpers/SatisfaccionColumns";
import { getTotalByMonthSLA } from "@/helpers/TableRabbeyTools";
import DetailSatisfaccionKpi from "@/views/modules/technical_support/KPI/Satisfaccion/DetailSatisfaccionKpi.vue";
import { formatArrayToElSelect } from "@/utils";

export default {
  name: "SatisfaccionPorClientesKPI",
  setup() {},
  components: { DetailSatisfaccionKpi, yearcomponent },
  data() {
    return {
      principalTable: true,
      loadingDetails: true,
      deals: false,
      formpayment: false,
      year: new Date().getFullYear(),
      value: "",

      typeServices: [],
      Valor: [
        { value: 0, label: "Todas las Solicitudes" },
        { value: 1, label: "Calificadas" }
      ],
      types: [
        { value: 0, label: "Todos" },
        { value: 2, label: "MagyTrack" },
        { value: 14, label: "TPD" },
        { value: 15, label: "NCF Movil" },
        { value: 16, label: "SeaHorse" },
        { value: 17, label: "MagyPago" },
        { value: 18, label: "Magylottery" }
      ],
      SellerName: "",
      contacts: [],
      loadingContacts: false,
      month: "",
      MontlyTarget: "",
      AccountNumber: "",
      serviceTypeID: 0,
      product: 0,
      valoracionTypeID: 0,
      InvoiceNum: "",
      ContactEmail: "",
      ProductList: [],
      form: {
        currentdate: "",
        newdate: "",
        comment: "",
        contactCode: ""
      },
      columns: [
        {
          prop: "tecnico",
          name: "Tecnico",
          minWidth: 220,
          fixed: true
        },
        ...Months
      ],
      columns2: [
        {
          prop: "technical",
          name: "Tecnico",
          minWidth: 220,
          fixed: true
        },
        ...this.mapOb(Months)
      ],
      columnsComments: [...commentColumns],
      items: [],
      comments: [],
      Dcoments: false,
      commentloading: false,
      StarTracker: {
        Compliment: 1
      },
      technicalTracker: []
    };
  },
  mounted() {
    this.$refs.yearC.Year = this.year;
  },
  created() {
    this.getData();
    this.$store.dispatch("request_types/all");
    this.$store.dispatch("products/all");

    this.$http
      .get("/api/KpiTechnicalSupport/getTypeServicesSLA", {
        params: { companyId: this.currentCompany }
      })
      .then(({ data }) => {
        this.typeServices = this.formatArrayToElSelect(data, {
          value: "Id",
          label: "Description"
        });
        this.typeServices.unshift({ value: 0, label: "Todos los Servicios" });
      });
  },
  watch: {
    list_products() {
      this.list_products.unshift({ value: 0, label: "Todos los Productos" });
    },
    list_types_to_select() {
      this.list_types_to_select.unshift({
        value: 0,
        label: "Tipos de Solicitudes"
      });
    }
  },
  computed: {
    ...mapGetters({
      list_types_to_select: "request_types/list_to_select",
      list_products: "products/list_products"
    }),
    isValid: function () {
      return this.form.comment.trim().length > 5 && this.form.newdate !== null;
    },
    groupItems() {
      return this._.groupBy(this.items, "NombreCliente");
    }
  },
  methods: {
    getTotalByMonthSLA,
    formatArrayToElSelect,
    getPorcentajeByUserAndMonth(month, techinicalName, year) {
      const KpiTechnicalSupport = this.groupItems[techinicalName];
      if (KpiTechnicalSupport === undefined) {
        return 0;
      }
      let countStar = 0;
      for (let index = 0; index < KpiTechnicalSupport.length; index++) {
        const element = KpiTechnicalSupport[index];
        const fecha = this.$moment(element.fecha, "YYYY-MM-DDTHH:mm:ss.SSS");
        const elementMonth = fecha.format("M");
        const elementYear = fecha.format("YYYY");
        if (month === elementMonth && year === elementYear) {
          countStar++;
        }
      }
      const suma = countStar;
      let Promedio = suma > 0 ? countStar / suma : 0;
      let Porcentaje = Promedio > 0 ? (Promedio / 5) * 100 : 0;

      return Porcentaje;
    },
    openDetail(mes, row) {
      // console.log("row: ", row, "\nmes: ", mes);
      this.$refs.details.show(row, mes, this.year);
    },
    getProductSelected() {
      return this.product;
    },
    getValoracionSelected() {
      return this.valoracionTypeID;
    },
    getServiceTypeSelected() {
      return this.serviceTypeID;
    },
    mapOb(data) {
      //console.log("data mapOb: ", data);
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        element.cellAtrrs = {
          getProductSelected: this.getProductSelected,
          getServiceTypeSelected: this.getServiceTypeSelected,
          getValoracionSelected: this.getValoracionSelected,
          openDetail: this.openDetail,
          ...element.cellAtrrs
        };
      }
      return data;
    },
    handler_year(_year) {
      this.year = _year;
      this.getData();
    },

    handlerChangesProduct(_Product) {
      this.product = _Product;
      this.getData();
    },

    handlerChanges(_valoracion) {
      this.valoracionTypeID = _valoracion;
      this.getData();
    },
    handlerChangesServices(_Service) {
      this.serviceTypeID = _Service;
      this.getData();
    },
    handleClose() {
      this.form.currentdate = "";
      this.form.newdate = "";
      this.form.comment = "";
      this.form.contactCode = "";
      this.AccountNumber = "";
      this.InvoiceNum = "";
      this.ContactEmail = "";
    },
    getData() {
      let params = {
        year: this.year,
        companyID: this.currentCompany,
        product: this.product,
        serviceTypeID: this.serviceTypeID,
        valoracionTypeID: this.valoracionTypeID
      };

      this.$store.commit("rabbey_table/loading");
      this.$http
        .get("/api/KpiTechnicalSupport/GetKpiSatisfaccion", {
          params: params
        })
        .then(({ data }) => {
          //console.log("data KpiSatisfaccion: ", data);
          this.items = data;
          this.$store.commit("rabbey_table/items", data);

          // Agrupar solicitudes por vendedor
          const technicalsGroup = this._.groupBy(data, "NombreCliente");
          // Lista de nombres de tecnicos
          const technicals = Object.keys(technicalsGroup);
          // Cantidad de estrellas
          const limitOfStars = 5;

          let t = {};
          this.technicalTracker = [];

          // Iterar entre cada tecnico
          for (let index = 0; index < technicals.length; index++) {
            // Obtener el nombre del tecnico actual
            const techinicalName = technicals[index];

            // Inicializar objeto del tecnico
            t = {
              clientCode: "",
              technicalId: 0,
              technical: techinicalName,
              1: 0,
              2: 0,
              3: 0,
              4: 0,
              5: 0,
              6: 0,
              7: 0,
              8: 0,
              9: 0,
              10: 0,
              11: 0,
              12: 0,
              total: 0
            };

            // Obtener las solicitudes del tecnico actual
            const solicitudes = technicalsGroup[techinicalName];
            // Obtener la primera solicitud
            const primeraSolicitud = solicitudes[0];
            // Obtener la fecha de la solicitud y formatear con moment
            const fecha = this.$moment(
              primeraSolicitud.fecha,
              "YYYY-MM-DDTHH:mm:ss.SS"
            );
            // Obtener el year de la solicitud
            const year = parseInt(fecha.format("YYYY"));
            t.clientCode = primeraSolicitud.ClientCode;
            // Asignar tecnico id
            t.technicalId = primeraSolicitud.AssignedTechnicianId;
            // t.valoracion = primeraSolicitud.valoracion;

            // Objeto acumulador de valores
            let monthTracker = {
              1: {
                valoracion: 0,
                count: 0
              },
              2: {
                valoracion: 0,
                count: 0
              },
              3: {
                valoracion: 0,
                count: 0
              },
              4: {
                valoracion: 0,
                count: 0
              },
              5: {
                valoracion: 0,
                count: 0
              },
              6: {
                valoracion: 0,
                count: 0
              },
              7: {
                valoracion: 0,
                count: 0
              },
              8: {
                valoracion: 0,
                count: 0
              },
              9: {
                valoracion: 0,
                count: 0
              },
              10: {
                valoracion: 0,
                count: 0
              },
              11: {
                valoracion: 0,
                count: 0
              },
              12: {
                valoracion: 0,
                count: 0
              }
            };

            // Iterar entre las solicitudes del tecnico actual, y sumar sus valores por mes y year
            for (let index = 0; index < solicitudes.length; index++) {
              // Obtener solicitud
              const solicitud = solicitudes[index];
              // Obtener fecha
              const fecha = this.$moment(
                solicitud.fecha,
                "YYYY-MM-DDTHH:mm:ss.SS"
              );
              // Obtener mes de la solicitud
              const elementMonth = parseInt(fecha.format("M"));
              // Obtener year de la solicitud
              const elementYear = parseInt(fecha.format("YYYY"));

              // Bucle similuador de mes, para sumar los valores del mismo mes y year
              for (let month = 1; month < 13; month++) {
                if (month === elementMonth && year === elementYear) {
                  monthTracker[month].valoracion += solicitud.valoracion;
                  monthTracker[month].count++;
                }
              }
            }

            // Calcular porcentaje por mes
            let sumAssessment = 0;
            let countRequest = 0;
            for (let month = 1; month < 13; month++) {
              const { valoracion, count } = monthTracker[month];
              sumAssessment += valoracion;
              countRequest += count;

              const sumValores = valoracion / count;

              t[`${month}`] =
                sumValores > 0 ? (sumValores / limitOfStars) * 100 : 0;
            }

            // Calcular el total de la linea
            const sumTotal = sumAssessment / countRequest;
            t.total = sumTotal > 0 ? (sumTotal / limitOfStars) * 100 : 0;

            // Agregar tecnico
            this.technicalTracker.push(t);
          }
        })
        .finally(() => {
          this.$store.commit("rabbey_table/success");
          this.principalTable = false;
        });
    },
    TotalMes: function () {
      if (this.technicalTracker.length <= 0) {
        return 0;
      }

      return this.technicalTracker
        .filter((item) => item.valoracion > 0)
        .map((item) => item.valoracion)
        .reduce((a, c) => a + c);
    }
  }
};
</script>

<style scoped>
#table-card td {
  padding-left: 10px;
}
.col-p {
  padding: 0 10px;
  box-sizing: border-box;
}
</style>
